// extracted by mini-css-extract-plugin
export default {"fr-view":"HelpTooltip_fr-view__zhs0N","intent-ia":"HelpTooltip_intent-ia__eoypq"};